// @ts-nocheck
import fallbackImage from "@assets/images/fallback-image.svg";
import favoriteTag from "@assets/images/icon-games-crown.svg";
import {useGetTopGames} from "@hooks/gamesList/useGetTopGames";
import React from "react";
import {useNavigate} from "react-router-dom";
import {GameCarouselRow} from "@/components";
import {useAuthStore} from "@/store/useAuth.store";
import {useGameMetadataStore} from "@/store/useGameMetadataStore";
import {
  gameCardCls,
  gameCardImageCls,
  gameCardLoadingCls,
  gameCardNameCls,
  gameCardOverlayCls,
  gameCardPlayBtnCls,
  gameCardTagBaseCls,
} from "../_gameCardShared";

const favoriteTagCls = `${gameCardTagBaseCls} h-6 w-auto`;

export const TopGames = ({provider}) => {
  const {data} = useGetTopGames(provider && provider !== "all" ? {provider, limit: 6} : {limit: 6});
  const navigate = useNavigate();
  const authStatus = useAuthStore(state => state.authStatus);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);

  const initializeGames = useGameMetadataStore(state => state.initializeGames);
  const getGameById = useGameMetadataStore(state => state.getGameById);
  const gamesLoading = useGameMetadataStore(state => state.loading);
  const gamesInitialized = useGameMetadataStore(state => state.initialized);

  React.useEffect(() => {
    if (!gamesInitialized && !gamesLoading) {
      initializeGames();
    }
  }, [gamesInitialized, gamesLoading, initializeGames]);

  const topGames = React.useMemo(() => {
    const listTopGames = data?.data?.data || [];
    if (gamesLoading || !gamesInitialized) return [];
    return listTopGames.slice(0, 6).map(topGame => {
      const game = getGameById(topGame?.game_id, topGame?.game_provider);
      return {
        ...topGame,
        icon: game?.icon || fallbackImage,
        provider: game?.provider || topGame?.game_provider,
        name: game?.name || topGame?.game_name,
        id: game?.id || topGame?.game_id || topGame?.id,
      };
    });
  }, [data, getGameById, gamesLoading, gamesInitialized]);

  const handleGameClick = React.useCallback(
    (gameProvider, gameId) => {
      if (authStatus === "authenticated") {
        navigate(`/games/${gameProvider}/${gameId}`);
      } else {
        handleShowAuthModal();
      }
    },
    [authStatus, navigate, handleShowAuthModal]
  );

  const renderCard = (game, idx) => (
    <div
      key={game?.id || idx}
      className={gameCardCls}
      onClick={() => handleGameClick(game?.provider, game?.id)}
    >
      <img
        src={game?.icon || fallbackImage}
        alt={game?.name || ""}
        onError={e => {
          e.target.onerror = null;
          e.target.src = fallbackImage;
        }}
        className={gameCardImageCls}
      />
      <img
        src={favoriteTag}
        alt="Favorito"
        className={favoriteTagCls}
      />
      <div className={gameCardOverlayCls}>
        <span className={gameCardNameCls}>{game?.name}</span>
        <button
          type="button"
          className={gameCardPlayBtnCls}
          onClick={e => {
            e.stopPropagation();
            handleGameClick(game?.provider, game?.id);
          }}
        >
          Jugar Ya
        </button>
      </div>
    </div>
  );

  const isLoading = gamesLoading || !gamesInitialized;
  const cards = isLoading
    ? Array.from({length: 6}).map((_, i) => (
        <div
          // biome-ignore lint/suspicious/noArrayIndexKey: static placeholder list
          key={`ph-${i}`}
          className={`${gameCardCls} ${gameCardLoadingCls}`}
        />
      ))
    : topGames.map((game, i) => renderCard(game, i));

  return (
    <GameCarouselRow
      id="topGames"
      icon="⭐"
      title="Los Favoritos"
      subtitle="Sueltan plata y son muy queridos"
      subtitleIcon="🫶"
      viewAllPath="/gameslist/all"
    >
      {cards}
    </GameCarouselRow>
  );
};
